<template>
    <VueDatamaps
        v-if="data.length"
        awsRegions
        arc
        projection="Mercator"
        :arcConfig="arcConfig"
        :awsRegionsConfig="awsRegionsConfig"
        :geographyConfig="geographyConfig"
        @custom:popup-region="customPopupRegion"
    >
        <template slot="hoverRegionInfo" v-if="hoverData.name">
            <div class="hoverinfo">
                <strong>{{ hoverData && hoverData.fullName }}</strong><br>
            </div>
        </template>
    </VueDatamaps>
</template>

<script>
import useCommonData from '@/composables/useCommonData'
import { computed, toRefs, ref } from '@vue/composition-api'
import { VueDatamaps } from 'vue-datamaps'
export default {
    components: {
        VueDatamaps
    },
    props: {
        data: {
            default: function () {
                return []
            },
            type: Array
        }
    },
    setup (props, context) {
        const { region } = useCommonData()
        const activeKeys = ref([])
        const keys = ref([])
        const hoverData = ref({})
        const { data } = toRefs(props)
        const geographyConfig = computed(() => {
            return {
                popupOnHover: false,
                highlightOnHover: false,
                borderWidth: 0.3
            }
        })
        const awsRegionsConfig = computed(() => {
            const data = activeKeys.value.map(key => {
                return {
                    code: key,
                    fillKey: 'active'
                }
            })

            return {
                data,
                popupTemplate: true,
                popupOnHover: true,
                borderColor: 'transparent',
                showPrivateRegions: true,
                region: region.value.map(item => {
                    return { ...item, color: '#ff9f43' }
                })
            }
        })
        const regionMap = computed(() => {
            return region.value.reduce((accumulator, currentValue) => {
                accumulator[currentValue.key] = {
                    name: currentValue.name,
                    code: currentValue.code,
                    public: currentValue.public === 'AWS Region'
                }
                return accumulator
            }, {})
        })
        const convertUsageType = (array) => {
            activeKeys.value = []
            keys.value = []
            return array.map(item => {
                const usageTypeArray = item.usageType.split('-')
                if (item.productCategory === 'Amazon Data Transfer Multi Region' && ~item.usageType.indexOf('Out-Bytes')) {
                    const origin = (regionMap.value[usageTypeArray[0]] && regionMap.value[usageTypeArray[0]].code) || undefined
                    const destination = (regionMap.value[usageTypeArray[1]] && regionMap.value[usageTypeArray[1]].code) || undefined
                    const key = `${origin}-${destination}`
                    if (origin && !activeKeys.value.includes(origin)) {
                        activeKeys.value.push(origin)
                    }
                    if (destination && !activeKeys.value.includes(destination)) {
                        activeKeys.value.push(destination)
                    }
                    if (origin && destination && !keys.value.includes(key)) {
                        keys.value.push(key)
                        return {
                            origin,
                            destination,
                            color: '#ff9f43'
                        }
                    }
                } else if (item.productCategory === 'Amazon Data Transfer Multi Region' && ~item.usageType.indexOf('In-Bytes')) {
                    const origin = (regionMap.value[usageTypeArray[1]] && regionMap.value[usageTypeArray[1]].code) || undefined
                    const destination = (regionMap.value[usageTypeArray[0]] && regionMap.value[usageTypeArray[0]].code) || undefined
                    const key = `${destination}-${origin}`
                    if (origin && !activeKeys.value.includes(origin)) {
                        activeKeys.value.push(origin)
                    }
                    if (destination && !activeKeys.value.includes(destination)) {
                        activeKeys.value.push(destination)
                    }
                    if (origin && destination && !keys.value.includes(key)) {
                        keys.value.push(key)
                        return {
                            origin,
                            destination,
                            color: '#ff9f43'
                        }
                    }
                }
            })
        }
        const filteredData = computed(() => {
            return convertUsageType(data.value).filter(value => value && value.origin && value.destination)
        })
        const arcConfig = computed(() => {
            return {
                popupOnHover: false,
                popupTemplate: false,
                arcSharpness: 2.5,
                data: filteredData.value,
                greatArc: true,
                animationSpeed: 2000
            }
        })
        const customPopupRegion = ({ datum }) => {
            hoverData.value = datum
        }
        return {
            hoverData,
            filteredData,
            geographyConfig,
            arcConfig,
            awsRegionsConfig,
            customPopupRegion
        }
    }
}
</script>

<style>
.hoverinfo {
    z-index: 2000;
}
</style>
